'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    calendar: {
      boxShadow: theme.calendar.boxShadow,
      boxSizing: 'border-box',
      userSelect: 'none',
      backgroundColor: theme.calendar.mainBgColor,
      flexDirection: 'column',
      borderRadius: theme.calendar.borderRadius
    },
    visible: {
      display: 'inline-flex'
    },
    hidden: {
      display: 'none'
    },
    footer: {
      paddingTop: 12,
      paddingBottom: 12
    },
    footerRow: {
      paddingTop: 4,
      paddingBottom: 4,
      display: 'flex',
      alignItems: 'center'
    },
    footerLabel: {
      flex: '0 0 auto',
      width: 70,
      marginRight: 8,
      position: 'relative',
      top: -1
    },
    timeContainer: {
      display: 'flex',
      alignItems: 'center',
      width: 85,
      flexShrink: 0
    },
    time: {
      paddingBottom: 0,
      paddingTop: 0,
      '& .field': {
        borderRadius: theme.calendar.borderRadius,
        borderWidth: 1,
        borderColor: theme.calendar.timeBorderColor + ' !important',
        borderStyle: 'solid',
        padding: '10px 7px 11px 8px',
        alignItems: 'center',
        '& input': {
          textAlign: 'center'
        }
      },
      '&.focus .field': {
        borderColor: theme.calendar.timeBorderActiveColor + ' !important'
      }
    },
    timeSeparator: {
      padding: '0 4px',
      position: 'relative',
      top: -2
    },
    selectContainer: {
      width: '100%'
    },
    select: {
      '& > *:first-child': {
        paddingBottom: 0,
        paddingTop: 0
      },
      // TODO - обновить стили когда будет стилизован Select
      '& .field': {
        borderRadius: theme.calendar.borderRadius,
        borderWidth: 1,
        borderColor: theme.calendar.timeBorderColor + ' !important',
        borderStyle: 'solid',
        padding: '10px 7px 11px 8px',
        alignItems: 'center'
      },
      '& .focus .field': {
        borderColor: theme.calendar.timeBorderActiveColor + ' !important'
      },
      '& .rightIcon': {
        '& .fill': {
          fill: theme.calendar.timezoneIconColor
        },
        '& .stroke': {
          stroke: theme.calendar.timezoneIconColor
        }
      }
    },
    confirmButton: {
      width: '100%'
    },
    medium: {
      width: 320,
      padding: '8px 8px 16px 8px'
    },
    small: {
      width: 240,
      padding: '12px',
      '& $footer': {
        paddingTop: 8,
        paddingBottom: 8
      },
      '& $footerLabel': {
        width: 60
      },
      '& $time, & $select': {
        '& .field': {
          padding: '3px 7px 4px 8px'
        },
        '& input': {
          fontSize: 12
        }
      }
    }
  };
};